import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './CategoryCarousel.module.css';
import voltar from '../../assets/voltarIcon.png';
import prosseguir from '../../assets/passarIcon.png';

interface Category {
  name: string;
  image?: string;
  altImage: string;
}

interface CategoryCarouselProps {
  categories: Category[];
  type: 'categories' | 'brands' | 'problems' | 'solutions';
}

const CategoryCarousel: React.FC<CategoryCarouselProps> = ({ categories, type }) => {
  const [startIndex, setStartIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(5);
  const [itemWidth, setItemWidth] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  const navigate = useNavigate();
//ok
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width >= 1200) {
        setVisibleCount(5);
      } else if (width >= 992) {
        setVisibleCount(4);
      } else if (width >= 768) {
        setVisibleCount(3);
      } else {
        setVisibleCount(2);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (containerRef.current) {
      const containerWidth = containerRef.current.offsetWidth;

      const gapPx = 72;

      const totalGap = gapPx * (visibleCount - 1);

 
      const newWidth = (containerWidth - totalGap) / visibleCount;
      setItemWidth(newWidth);

      if (startIndex > categories.length - visibleCount) {
        setStartIndex(Math.max(0, categories.length - visibleCount));
      }
    }
  }, [visibleCount, categories.length, startIndex]);

  const handleCategoryClick = (category: string) => {
    navigate(`/search/1?${type}=${category}`);
  };

  const nextCategory = () => {
    setStartIndex(prev => Math.min(prev + 1, categories.length - visibleCount));
  };
  const prevCategory = () => {
    setStartIndex(prev => Math.max(prev - 1, 0));
  };

  return (
    <div className={styles.categorycarouselContainer}>
      <button
        onClick={prevCategory}
        className={`${styles.carouselButton} ${styles.carouselButtonLeft}`}
        disabled={startIndex === 0}
      >
        <img src={voltar} alt="Voltar" />
      </button>

      <div className={styles.itenscontainer} ref={containerRef}>
        <div
          className={styles.itens}
          style={{
            transform: `translateX(-${startIndex * (itemWidth + 72)}px)`,
            transition: 'transform 0.3s ease',
          }}
        >
          {categories.map((category, idx) => (
            <div
              key={idx}
              className={styles.categoria}
              onClick={() => handleCategoryClick(category.name)}
              style={{
                width: itemWidth,
                marginRight: idx === categories.length - 1 ? 0 : '32px',
                height: itemWidth,
                flex: '0 0 auto',
              }}
            >
              {category.image && (
                <img src={category.image} alt={category.altImage} style={{ width: '100%', height: 'auto' }} />
              )}
              <p className={styles.paragraph}>{category.name}</p>
            </div>
          ))}
        </div>
      </div>

      <button
        onClick={nextCategory}
        className={`${styles.carouselButton} ${styles.carouselButtonRight}`}
        disabled={startIndex >= categories.length - visibleCount}
      >
        <img src={prosseguir} alt="Próxima" />
      </button>
    </div>
  );
};

export default CategoryCarousel;
